import { useState, useEffect, useContext } from 'react'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import DeleteIcon from '@mui/icons-material/Delete'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { getFacebookSummaryPaid } from '../../helpers/remoteData'
import { ClientContext } from '../../providers/ClientProvider'

function FacebookSummaryPaidWidget({ accountId, accessToken, pageUrl, isAdmin, setSelectedWidget, el, moveUp, moveDown }) {
  const { client } = useContext(ClientContext)

  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState<Array<any>>([])

  useEffect(() => {
    const _fetch = async () => {
      setLoading(true)

      try {
        const _rows = await getFacebookSummaryPaid(accountId, accessToken)

        if (_rows) {
          setRows(_rows.data)
        }

        setLoading(false)
      }
      catch (e) {
        console.log('Meta error')
        
        setLoading(false)
      }
    }

    _fetch()
  }, [accountId, accessToken])

  return (
    <div className='col-12 col-md-6 col-xl-4 mb-8 d-inline-block'>
      <div className='card shadow h-100'>
        {
          isAdmin && (
            <div className='card-header justify-content-end'>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                onClick={() => moveUp(el)}
              >
                <ArrowUpwardIcon />
              </button>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                onClick={() => moveDown(el)}
              >
                <ArrowDownwardIcon />
              </button>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                data-bs-toggle='modal'
                data-bs-target='#modal_delete_widget'
                onClick={() => setSelectedWidget(el)}
              >
                <DeleteIcon />
              </button>
            </div>
          )
        }
        {
          loading ? 
            <div className='card-body text-center'>
              <div className='spinner-border spinner-border-sm' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          :
            <div className='card-body'>
              <h4 className='d-flex align-items-center mb-0 fw-boldest'>
                <span className='me-3'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M16.785 2.54992C15.855 2.44492 14.925 2.39992 13.995 2.41492C10.92 2.41492 9 4.37992 9 7.54492V9.68992H6.405C6.15 9.68992 5.94 9.89992 5.94 10.1549V13.6799C5.94 13.9349 6.15 14.1449 6.405 14.1449H9V21.2249C9 21.4799 9.21 21.6899 9.465 21.6899H13.11C13.365 21.6899 13.575 21.4799 13.575 21.2249V14.1449H16.155C16.38 14.1449 16.575 13.9799 16.605 13.7399L17.055 10.2149C17.085 9.95992 16.905 9.73492 16.665 9.70492C16.65 9.70492 16.62 9.70492 16.605 9.70492H13.56V7.90492C13.56 7.01992 13.74 6.64492 14.85 6.64492H16.725C16.98 6.64492 17.19 6.43492 17.19 6.17992V3.01492C17.19 2.77492 17.01 2.57992 16.785 2.54992ZM16.275 5.71492H14.865C12.885 5.71492 12.66 6.95992 12.66 7.88992V10.1399C12.66 10.3949 12.87 10.6049 13.125 10.6049H16.095L15.75 13.2149H13.11C12.855 13.2149 12.645 13.4249 12.645 13.6799V20.7599H9.915V13.6799C9.915 13.4249 9.705 13.2149 9.45 13.2149H6.87V10.6049H9.465C9.72 10.6049 9.93 10.3949 9.93 10.1399V7.54492C9.93 4.90492 11.46 3.32992 14.01 3.32992C14.94 3.32992 15.765 3.37492 16.275 3.41992V5.71492Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M13.38 21.71H9.735C9.555 21.71 9.375 21.635 9.255 21.515C9.12 21.38 9.06 21.215 9.06 21.035V14.18H6.675C6.495 14.18 6.315 14.105 6.195 13.985C6.06 13.85 6 13.685 6 13.505V9.95C6 9.77 6.075 9.59 6.195 9.47C6.33 9.335 6.495 9.275 6.675 9.275H9.045V7.355C9.045 4.055 11.055 2 14.265 2C15.21 2 16.14 2.045 17.07 2.15C17.415 2.195 17.67 2.48 17.67 2.825V5.99C17.67 6.365 17.37 6.68 16.98 6.68H15.105C14.13 6.68 14.04 6.95 14.04 7.715V9.29H16.86C16.89 9.29 16.92 9.29 16.95 9.29C17.325 9.335 17.595 9.68 17.535 10.055L17.085 13.58C17.04 13.925 16.755 14.18 16.41 14.18H14.055V21.035C14.055 21.215 13.98 21.395 13.86 21.515C13.725 21.635 13.56 21.71 13.38 21.71ZM6.675 9.725C6.615 9.725 6.555 9.755 6.51 9.8C6.465 9.845 6.435 9.905 6.435 9.965V13.49C6.435 13.55 6.465 13.61 6.51 13.655C6.555 13.7 6.615 13.73 6.675 13.73H9.495V21.035C9.495 21.095 9.525 21.155 9.57 21.2C9.615 21.245 9.675 21.275 9.735 21.275H13.38C13.44 21.275 13.5 21.245 13.545 21.2C13.59 21.155 13.62 21.095 13.62 21.035V13.73H16.425C16.545 13.73 16.635 13.64 16.65 13.52L17.1 9.995C17.115 9.86 17.025 9.755 16.905 9.74C16.89 9.74 16.89 9.74 16.875 9.74H13.605V7.7C13.605 6.74 13.845 6.215 15.12 6.215H16.995C17.13 6.215 17.235 6.11 17.235 5.975V2.825C17.235 2.705 17.145 2.615 17.04 2.6C16.125 2.51 15.21 2.45 14.28 2.465C11.34 2.465 9.51 4.34 9.51 7.37V9.74H6.675C6.675 9.725 6.675 9.725 6.675 9.725ZM13.14 20.795H9.96V13.49C9.96 13.43 9.93 13.37 9.885 13.325C9.84 13.28 9.78 13.25 9.72 13.25H6.915V10.19H9.735C9.87 10.19 9.975 10.085 9.975 9.95V7.355C9.975 4.58 11.58 2.915 14.28 2.915C15.36 2.915 16.23 2.975 16.56 3.005L16.77 3.02V5.735H15.135C13.38 5.735 13.155 6.725 13.155 7.685V9.935C13.155 9.995 13.185 10.055 13.23 10.1C13.275 10.145 13.335 10.175 13.395 10.175H16.635L16.245 13.235H13.38C13.245 13.235 13.14 13.34 13.14 13.475V20.795ZM10.41 20.345H12.69V13.49C12.69 13.115 12.99 12.8 13.38 12.8H15.825L16.11 10.64H13.38C13.2 10.64 13.02 10.565 12.9 10.445C12.765 10.31 12.705 10.145 12.705 9.965V7.715C12.705 6.095 13.5 5.315 15.135 5.315H16.32V3.44C15.915 3.41 15.165 3.365 14.28 3.365C11.865 3.365 10.425 4.85 10.425 7.355V9.965C10.425 10.34 10.125 10.655 9.735 10.655H7.365V12.815H9.735C9.915 12.815 10.095 12.89 10.215 13.01C10.35 13.145 10.41 13.31 10.41 13.49V20.345Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                  </svg>
                </span>
                {
                  pageUrl ? 
                    <Link to={pageUrl} className='text-dark'>Latest Facebook Ads</Link>
                  :
                    <span>Latest Facebook Ads</span>
                }
              </h4>

              <div>
                {
                  rows.map((r, i) => {
                    return (
                      <div key={`instagram-summary-${i}`} className='mt-8 d-flex align-items-center'>
                        <img src={r.ads.data[0].adcreatives.data[0].thumbnail_url} alt='Thumbnail' className='rounded' height={48} width={48} />
                        <div className='ms-4'>
                          <div className='mb-1'>
                            <span className='badge text-white' style={r.status === 'ACTIVE' ? { backgroundColor: '#009ef7' } : { backgroundColor: '#838383' }}>{r.status.toLowerCase().replace(/(^| )(\w)/g, (x) => x.toUpperCase())}</span>
                            <span className='fw-boldest ms-3'>{r?.stop_time && r?.start_time && moment(r.stop_time).isBefore(moment()) ? moment(r.stop_time).format('MM/DD/YY') : `${moment(r.stop_time).diff(moment(r.start_time), 'days')} days`}</span>
                          </div>
                          <div className='fs-0 fw-bold'>
                            {r?.objective && r?.objective.replace('_', ' ').toLowerCase().replace(/(^| )(\w)/g, (x) => x.toUpperCase())}
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
        }
      </div>
    </div>
  )
}

export default FacebookSummaryPaidWidget
